import {
  PlusCircleOutlined
} from '@ant-design/icons';
import { Button } from 'antd';
import CommonCard from 'commons/Layout/CommonCard';
import { openNotification } from 'commons/Notifications';
import React, { useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ServiceAirTree from 'services/airTree';
import ServiceLocations from 'services/locations';
import { FormatDate } from 'utils/helpers/date_helpers';
import CommonTable from '../../commons/CommonTable';
import { AirTreeProjectTableColumns } from './components/tableColumns';

const AirtreeProjectList = (props) => {
  const airTreeProjectsTable = useRef(undefined);
  let navigate = useNavigate();
  const [regioni, setRegioni] = useState([])

  // Set regioni
  useMemo(() => ServiceLocations.listRegioni({}).then(response => {
    const responseMap = response?.data?.map(regione => {
      return { value: regione?.id, text: regione?.regione }
    })
    setRegioni(responseMap)
  }), [])

  // Delete record
  const deleteRecord = async (record) => {

    if (record) {

      // Delete
      ServiceAirTree.delete(record?.id)
        .then((success) => {
          openNotification({
            message: 'OK',
            description: 'Scheda eliminata correttamente',
            type: 'success',
          });
          if (airTreeProjectsTable.current) {
            airTreeProjectsTable.current.refresh();
          }
        })
    }
  };

  // Clone record
  const cloneRecord = async (record) => {

    if (record) {

      ServiceAirTree.clone(record?.id)
        .then((success) => {
          openNotification({
            message: 'OK',
            description: 'Progetto duplicato correttamente',
            type: 'success',
          });
          if (airTreeProjectsTable.current) {
            airTreeProjectsTable.current.refresh();
          }
        })
    }
  };

  // Update record
  const upsertRecord = (record: any = null) => {
    if (record) {
      navigate("/airtree-modify/" + record?.id, { replace: true })
    } else {
      navigate("/airtree-create/", { replace: true })
    }
  };

  // View record
  const viewRecord = (record: any = null) => {
    if (record) {
      navigate("/airtree-view/" + record?.id, { replace: true })
    }
  };

  // const listRegioni = () => ServiceLocations.listRegioni({}).then(response => {
  //   const responseMap = response?.data?.map(regione => {
  //     return { value: regione?.id, text: regione?.regione }
  //   })
  //   setRegioni(responseMap)
  // })

  return (
    <CommonCard title={<h2>AirTree: Lista progetti</h2>}>
      <Button
        icon={<PlusCircleOutlined />}
        onClick={() => upsertRecord()}
        type="primary"
        style={{ marginBottom: 16 }}
      >
        Crea nuovo progetto
      </Button>
      {regioni &&
        <CommonTable
          ref={airTreeProjectsTable}
          title="Lista progetti"
          scroll={{ x: 2400 }}
          debug={false}
          columns={AirTreeProjectTableColumns({ upsertRecord, deleteRecord, viewRecord, regioni, cloneRecord })}
          service={(paginationParams, filters) => {
            if (filters?.created_at) {
              filters.created_at = FormatDate(filters.created_at, 'YYYY-MM-DD');
            }
            if (filters?.simulation_date_start) {
              filters.simulation_date_start = FormatDate(filters.simulation_date_start, 'YYYY-MM-DD');
            }
            if (filters?.simulation_date_end) {
              filters.simulation_date_end = FormatDate(filters.simulation_date_end, 'YYYY-MM-DD');
            }
            return ServiceAirTree.listProjects({
              pagination: true,
              paginationParams,
              expand: "createdBy,regione",
              search: filters
            })
          }
          }
          pageSize={20}
          searchAllColumns={true}
          sortAllColumns={true}
        />}
    </CommonCard>
  );
}

export default AirtreeProjectList;
